export enum AccessibilityTestingType {
    URL_BASED_APPROACH = "URL_BASED_APPROACH",
    STEP_LEVEL_APPROACH = "STEP_LEVEL_APPROACH"
  }